<template>
  <listSuncategoriesComponent 
  :category = "category"
  />
</template>

<script>
import listSuncategoriesComponent from "@/views/categories_board/pages/list_subcategories/components/list_subcategories_component.vue";
export default {
  name: "categories",
  props: {
    category: {
      required: true
    },
  },
  components: {
    listSuncategoriesComponent,
  },
};
</script>

<style lang="css" scoped>
</style>
